/** @format */

import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WINDOW } from '@shared/data-access/services';
import { selectUserZipCode } from '@state/data-access';
import { HmfActionTextComponent } from '@dsg-tech/homefield-angular';
import { NgClass } from '@angular/common';
import { selectKillswitch } from '@pdp/data-access/state';

@Component({
	selector: 'pdp-feature-change-zip-code-button',
	styleUrl: './change-zip-code-button.component.scss',
	templateUrl: './change-zip-code-button.component.html',
	imports: [HmfActionTextComponent, NgClass]
})
export class ChangeZipCodeButtonComponent implements OnInit, OnDestroy {
	userZipCode$ = this.store.select(selectUserZipCode);
	zipcode: string;
	private UNSUBSCRIBE$: Subject<void> = new Subject();

	@Input() isSubtext = false;
	@Input() isDisabled = false;
	@Input() isSubtle = false;

	sameDayDeliveryEnabled = this.store.selectSignal(selectKillswitch('sameDayDeliveryEnabled'));

	constructor(
		@Inject(WINDOW) protected window: Window,
		private store: Store
	) {}

	ngOnInit() {
		this.userZipCode$.pipe(takeUntil(this.UNSUBSCRIBE$)).subscribe((zipcode) => {
			this.zipcode = zipcode;
		});
	}

	public ngOnDestroy(): void {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}

	openZipCodePanel() {
		this.window.headerFunctions.sameDayDelivery();
	}
}
